import React, { useState } from "react";
import "./LoanForm.css";
import { toast, ToastContainer } from "react-toastify";
import { IoClose } from "react-icons/io5";
import { useContactSlotMutation } from "../../slice/authApiSlice";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const LoanApplicationForm = ({ onClose }) => {
  const [contactSlot, { isLoading }] = useContactSlotMutation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phNumber: "",
    text: "",
  });

  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.name || !formData.email || !formData.phNumber || !formData.text) {
      toast.error("All fields are required.");
      return;
    }

    if (!emailRegex.test(formData.email)) {
      toast.error("Enter a valid email address.");
      return;
    }

    if (formData.phNumber.length !== 10 || isNaN(formData.phNumber)) {
      toast.error("Phone number must be 10 digits.");
      return;
    }

    try {
      const res = await contactSlot(formData).unwrap();
      toast.success("Loan application submitted successfully!");
      setFormData({ name: "", email: "", phNumber: "", text: "" });
      setShowSuccessPopup(true);
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to submit application. Please try again.");
    }
  };

  return (
    <div className="loan-form-overlay">
      <div className="loan-form-container">
        <div className="loan-form-header">
          <h2>Apply for a Loan</h2>
          <div className="loan-form-close-btn" onClick={onClose}>
            <IoClose />
          </div>
        </div>

        <form className="loan-form-body" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Enter your name"
            value={formData.name}
            onChange={handleChange}
          />
          <input
            type="text"
            name="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleChange}
          />
          <input
            type="text"
            name="phNumber"
            placeholder="Enter your phone number"
            value={formData.phNumber}
            onChange={handleChange}
          />
          <textarea
            name="text"
            placeholder="Enter additional details"
            value={formData.text}
            onChange={handleChange}
          />
          <button type="submit" disabled={isLoading}>
            {isLoading ? "Submitting..." : "Submit"}
          </button>
        </form>

        <ToastContainer />

        {showSuccessPopup && (
  <Modal
    open={showSuccessPopup}
    onClose={() => {
      setShowSuccessPopup(false);
      onClose();
    }}
    aria-labelledby="loan-success-modal-title"
    keepMounted
  >
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 420,
        maxWidth: "90%",
        bgcolor: "background.paper",
        borderRadius: 4,
        boxShadow: 24,
        fontFamily: "'Kumbh Sans', sans-serif",
        p: 4,
        textAlign: "center",
        position: "relative",
      }}
    >
      {/* Close Button */}
      <IconButton
        aria-label="close"
        onClick={() => {
          setShowSuccessPopup(false);
          onClose();
        }}
        sx={{
          position: "absolute",
          right: 12,
          top: 12,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>

      {/* Logo Circle */}
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: "50%",
          backgroundColor: "#f3f6f9",
          margin: "0 auto",
          mb: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img src={require("../../assets/images/Risoapp_1.png")} alt="Riso Logo" style={{ width: "50px" }} />
      </Box>

      {/* Title */}
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
        Thank You!
      </Typography>

      {/* Description */}
      <Typography sx={{ color: "text.secondary", fontSize: "15px" }}>
        Your loan application has been submitted successfully. <br />
        Our team will reach out to you shortly.
      </Typography>
    </Box>
  </Modal>
)}


      </div>
    </div>
  );
};

export default LoanApplicationForm;
